<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">Revaluation Bank/Cash Foreign Currency(FCY) 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="posting()" :key="postingLabel">
              <i class="fa fa-paper-plane"></i> {{postingLabel}}
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="4">
          <b-form-group label-cols=3 label="Periode">
                <vue-monthly-picker v-model="filter.periode" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth"></vue-monthly-picker>
          </b-form-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
              <thead>
                <tr>
                    <th style="width:100px" rowspan="2">Account Code</th>
                    <th rowspan="2">Account Name</th>
                    <th style="width:100px" rowspan="2">GL Account#</th>
                    <th style="text-align:center;width:60px;" rowspan="2">$,¥</th>
                    <th colspan="3" style="text-align:center">BEGINING BALANCE</th>
                    <th colspan="2" style="text-align:center;">RECEIPT (DEBIT)</th>
                    <th colspan="2" style="text-align:center;">PAYMENT (CREDIT)</th>
                    <th colspan="3" style="text-align:center;">ENDING BALANCE</th>
                    <th style="text-align:right;width:100px;" >Difference</th>
                </tr>
                <tr>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th style="width:100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th style="width:100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th style="width:100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th style="width:100px">Value ({{uanguser}})</th>
                    <th style="width:100px">Value ({{uanguser}})</th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="row in rekondata" :key="row.apinvkey">
                      <td >{{row.kode}}</td>
                      <td> {{row.namabank}}</td>
                      <td> {{row.kodeacc}}</td>
                      <td style="text-align:right" >{{row.matauang}} </td>
                      <td v-if="(row.totalaw)" style="text-align:right" >{{row.totalaw | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.kursaw)" style="text-align:right" width="90px">{{row.kursaw | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idraw)" style="text-align:right" >{{row.idraw | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.totalnew)" style="text-align:right" >{{row.totalnew | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.idrnew)" style="text-align:right" >{{row.idrnew | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.totalpay)" style="text-align:right" >{{row.totalpay | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.idrpay)" style="text-align:right" >{{row.idrpay | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.totalak)" style="text-align:right" >{{row.totalak | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.kursak)" style="text-align:right" width="90px">{{row.kursak | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idrak)" style="text-align:right" >{{row.idrak | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                      <td v-if="(row.selisih)" style="text-align:right" >{{row.selisih | numFormat('0,0.00')}}</td>
                      <td v-else ></td>
                  </tr>
                </tbody>
          </table>
      </div>
      <hr>
      <b-row >
        <b-col md="2">Total Begining :<span class="input-group-text">{{uanguser}} {{subtotal.totalAw | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Receipt/Debit : <span class="input-group-text">{{uanguser}} {{subtotal.totalNew | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Payment/Credit  : <span class="input-group-text">{{uanguser}} {{(subtotal.totalPay) | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Total Ending  : <span class="input-group-text">{{uanguser}} {{(subtotal.totalAk) | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Difference (Gain/Loss)<span class="input-group-text">{{uanguser}} {{subtotal.selisih | numFormat('0,0.00')}}</span></b-col>
        <b-col class="text-right">
          <button class="btn btn-primary mt-2 mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The <strong>Revaluation Bank/Cash Foreign Currency(FCY)</strong> will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The <strong>Revaluation Bank/Cash Foreign Currency(FCY)</strong> will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import bankreval from "../../apis/bankreval";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      postingLabel: 'Posting',
      reportUrl: null,
      filter: {tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      monthLabels:dropdown.monthLabels,
      rekondata : [],
      subtotal : {posting : -1},
    };
  },
  components: {VueMonthlyPicker,Loading},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
  created: async function(){
        this.filter.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tgl1=this.$store.state.user.tglaktif;
        this.filter.tgl2= this.filter.periode.format('YYYY-MM-DD');
  },  
  methods: {
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        // this.tahun=tgl2.format('YYYY');
        // this.$forceUpdate();
        this.filter.tgl2=tgl2.endOf('month').format('YYYY-MM-DD');
        console.log('this.filter.tgl2 : ',this.filter.tgl2);
    },
    onChangeMonth: async function (){
        var tgl=this.filter.periode;
        this.filter.tgl1=tgl.startOf('month').format('YYYY-MM-DD');
        this.filter.tgl2=tgl.endOf('month').format('YYYY-MM-DD');
        this.subtotal.posting = -1;
        console.log('this.filter : ',this.filter);
        this.$forceUpdate();
    },  

    process: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
         try {
          this.isLoading=true;
          const result = await bankreval.process(this.filter);
          this.rekondata =  result[0];
          this.subtotal = result[1][0];
          if ((this.subtotal.posting || 0) == 0) {
              this.postingLabel='Posting';     
          } else {
              this.postingLabel='Un Posting';     
          }
          this.isLoading=false;      
           
         } catch (error) {
            this.isLoading=false;      
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
           
         }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    },
    posting: async function () {
      if (this.subtotal.posting !== -1) {
        if ((this.subtotal.posting || 0) == 0) {
            this.showPostingConfirm = true;
        } else { 
        // if (this.subtotal.posting == 1) {
            this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn('Please do Process before Posting/UnPosting!');
      }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await bankreval.posting(this.filter);
            this.subtotal.posting=1;
            this.postingLabel='Un Posting';     
            // this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;      
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await bankreval.postingUndo(this.filter);
            this.subtotal.posting=0;
            this.postingLabel='Posting';     
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;      
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    printjv: async function()
    {
      if ((this.subtotal.posting || 0) == 1) {
          this.isLoading=true;
          try {
              this.showReport=true;
              this.reportUrl= await bankreval.printjv(this.filter);
              this.isLoading=false;
          } catch (error) {
            this.isLoading=false;      
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please do Posting before Print JV!');
        }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await bankreval.exportxls(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/treasury/home");
    }
  }
};
</script>
